// Core domain constants for Ali Construction PM portal

// 7 construction phases (matching the Excel structure)
export const PHASES = [
  { key: "1-Pre-construction", en: "Pre-Construction", zh: "前期准备", color: "#94a3b8", ink: "#64748b" },
  { key: "2-Foundation", en: "Foundation", zh: "地基", color: "#f59e0b", ink: "#b45309" },
  { key: "3-Framing", en: "Framing", zh: "框架", color: "#f97316", ink: "#c2410c" },
  { key: "4-Rough MEP", en: "Rough MEP", zh: "粗装机电", color: "#7B5CFF", ink: "#6a4be0" },
  { key: "5-Pre-Finishes", en: "Pre-Finishes", zh: "精装前", color: "#4F6BFF", ink: "#3B57F0" },
  { key: "6-Finishes", en: "Finishes", zh: "精装", color: "#10b981", ink: "#047857" },
  { key: "7-City Final", en: "City Final", zh: "市政验收", color: "#22c55e", ink: "#15803d" },
];

// 8 payment / collection milestones
export const PAY_STAGES = [
  { key: "signing_contract", en: "Signing Contract", zh: "签订合同" },
  { key: "planning_approved", en: "Planning Approved", zh: "规划批准" },
  { key: "pulling_permit", en: "Pulling Permit", zh: "获取许可" },
  { key: "framing_complete", en: "Framing Complete", zh: "框架完成" },
  { key: "mep_passing", en: "MEP Passing", zh: "机电通过" },
  { key: "drywall_install", en: "Drywall Install", zh: "石膏板安装" },
  { key: "floor_install", en: "Floor Install", zh: "地板安装" },
  { key: "final_building", en: "Final Building", zh: "最终验收" },
];

export const TEAMS = [
  { id: "team_norcal", name: "NorCal", zh: "北加州组" },
  { id: "team_1", name: "LA Team 1", zh: "LA一组" },
  { id: "team_2", name: "LA Team 2", zh: "LA二组" },
  { id: "team_3", name: "LA Team 3", zh: "LA三组" },
  { id: "team_sd", name: "San Diego", zh: "圣地亚哥组" },
];

// Payment status meta
export const PAY_STATUS = {
  not_due: { en: "Not Due", zh: "未到期", color: "#4b5b75", bg: "#f1f5f9" },
  pending_invoice: { en: "Pending Invoice", zh: "待开单", color: "#92400e", bg: "#fef3c7" },
  invoiced: { en: "Invoiced", zh: "已开单", color: "#1d4ed8", bg: "#dbeafe" },
  paid: { en: "Paid", zh: "已收款", color: "#166534", bg: "#dcfce7" },
};

// Demo user accounts (mocked auth on the frontend)
export const USERS = [
  { username: "admin", role: "admin", name: "David Chen", team: null, nameZh: "陈管理员" },
  { username: "engmgr", role: "eng_manager", name: "Frank Zhou", team: null, nameZh: "周经理" },
  { username: "ceo", role: "ceo", name: "Michael Ali", team: null, nameZh: "Ali 总裁" },
  { username: "finance", role: "finance", name: "Amy Liu", team: null, nameZh: "刘会计" },
  { username: "norcal", role: "member", name: "Kevin Zhang", team: "team_norcal", nameZh: "张工" },
  { username: "team1", role: "member", name: "Lucy Wang", team: "team_1", nameZh: "王工" },
  { username: "team2", role: "member", name: "Tom Zhao", team: "team_2", nameZh: "赵工" },
  { username: "team3", role: "member", name: "Grace Sun", team: "team_3", nameZh: "孙工" },
  { username: "sales_jasonwu", role: "sales", name: "Jason Wu", team: null, nameZh: "吴销售" },
  { username: "sales_emilychen", role: "sales", name: "Emily Chen", team: null, nameZh: "陈销售" },
  { username: "sales_michaellee", role: "sales", name: "Michael Lee", team: null, nameZh: "李销售" },
  { username: "cashier", role: "cashier", name: "Cathy Chen", team: null, nameZh: "陈出纳" },
];

// Project types
export const PROJECT_TYPES = [
  { key: "ADU", en: "ADU", zh: "ADU" },
  { key: "新建", en: "New Build", zh: "新建" },
  { key: "加建", en: "Addition", zh: "加建" },
];

// Sales & customer service pools (for the create-project form)
export const SALES_PEOPLE = ["Jason Wu", "Emily Chen", "Michael Lee", "Sophia Guo", "Ryan Tang"];
export const CS_PEOPLE = ["Nina Xu", "Peter Han", "Cindy Ma", "Leo Feng"];
export const DESIGNERS = ["Michael", "Jose F", "Cassie", "Arthi"];

export const phaseByKey = (key) => PHASES.find((p) => p.key === key) || PHASES[0];
export const payStageByKey = (key) => PAY_STAGES.find((p) => p.key === key);

// Completed pseudo-phase (project passed final city building inspection)
export const COMPLETED_INDEX = 7;
export const COMPLETED_PHASE = { key: "completed", en: "Completed", zh: "已完成", color: "#059669" };
export const DESIGN_PHASE = { key: "design", en: "Design", zh: "设计阶段", color: "#6366f1" };
export const getPhase = (idx) => (idx < 0 ? DESIGN_PHASE : idx >= COMPLETED_INDEX ? COMPLETED_PHASE : PHASES[idx] || PHASES[0]);

// ============================================================================
// 引擎 8 阶段（2026-10-24 新增）
// ----------------------------------------------------------------------------
// 需求背景（老板口径）：现场快照上传时选了哪个阶段（没选就是项目当前阶段），
// 项目文件「按阶段」图库就显示在哪个阶段下面，且轮播角标文字必须与阶段、
// 项目文件分组三者对得上。
// 问题：现场快照的上传下拉 / 轮播角标用的是后端施工引擎的 8 阶段名
// （backend/data/engine_workflow.json，与 data.phases 接口下发同源），
// 而项目文件「按阶段」分组此前用的是上面旧 7 阶段名（getPhase）——
// 「地基 vs 基础」「框架 vs 框架结构」等文字对不上，且旧表没有「拆除」。
// 这里把引擎 8 阶段名收编进前端常量，作为按阶段视图的统一展示口径；
// 与旧 7 阶段编号的映射和后端 engine_module.LEGACY_TO_ENGINE / LEGACY_MAP 严格同源，
// 改任何一侧都要同步另一侧。
// ============================================================================
export const ENGINE_PHASES = [
  { key: "eng-pre-construction", en: "Pre-Construction", zh: "开工前准备", color: "#94a3b8" },
  { key: "eng-demolition", en: "Demolition", zh: "拆除", color: "#ef4444" },
  { key: "eng-foundation", en: "Foundation", zh: "基础", color: "#f59e0b" },
  { key: "eng-framing", en: "Framing", zh: "框架结构", color: "#f97316" },
  { key: "eng-rough-mep", en: "Rough MEP", zh: "粗装 MEP", color: "#7B5CFF" },
  { key: "eng-pre-finishes", en: "Pre-Finishes", zh: "精装前", color: "#4F6BFF" },
  { key: "eng-finishes", en: "Finishes", zh: "精装收尾", color: "#10b981" },
  { key: "eng-city-final", en: "City Final", zh: "市政收尾验收", color: "#22c55e" },
  // 引擎阶段 8：已竣工（后端 hub_photo_add 允许 phase=8，engine_state.phaseIdx 可为 8）
  { key: "eng-completed", en: "Completed", zh: "已竣工", color: "#059669" },
];
// 旧 7 阶段编号(phaseIndex) → 引擎 8 阶段编号（同 backend engine_module.LEGACY_TO_ENGINE）
export const LEGACY_TO_ENGINE_PHASES = { 0: 0, 1: 2, 2: 3, 3: 4, 4: 5, 5: 6, 6: 7, 7: 8 };
// 引擎 8 阶段编号 → 旧 7 阶段编号（同 backend engine_module.LEGACY_MAP；引擎 0/1 都归旧 0）
export const ENGINE_TO_LEGACY_PHASES = { 0: 0, 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 7: 6, 8: 7 };

// Brand (blue-violet gradient · v2 design system)
export const CHART_COLORS = ["#4F6BFF", "#7B5CFF", "#06b6d4", "#10b981", "#f59e0b", "#ec4899", "#64748b", "#a855f7"];
export const BRAND = { from: "#4F6BFF", to: "#7B5CFF", dark: "#3B57F0", light: "#e1e7ff", grad: "linear-gradient(135deg, #4F6BFF 0%, #7B5CFF 100%)" };

// When a project ADVANCES into a phase, this collection milestone becomes due
// (engineering reaching the node auto-notifies finance)
export const PHASE_TO_PAYSTAGE = {
  0: "signing_contract",
  1: "pulling_permit",
  2: "planning_approved",
  3: "framing_complete",
  4: "mep_passing",
  5: "drywall_install",
  6: "floor_install",
};
